"use client";

import { useAppDispatch } from "@/store/hooks";
import { MenuData, setMenuData } from "@/store/slices/menuSlice";
import { useEffect } from "react";

export const MenuInitializer = ({ getMenuData }: { getMenuData: MenuData }) => {
  const dispatch = useAppDispatch();
  console.log("get menu data", getMenuData);

  useEffect(() => {
    const fetchAndSetMenuData = async () => {
      if (getMenuData) {
        dispatch(setMenuData(getMenuData));
      }
    };
    fetchAndSetMenuData();
  }, [dispatch, getMenuData]);

  // This component doesn't render anything
  return null;
};
